import Transition from '@ember/routing/-private/transition';
import Route from 'cio/routes/base';
import SubscriptionCenterLocalizationEditController from 'cio/pods/workspace-settings/subscription-center/localization/edit/controller';

export default class SubscriptionCenterLocalizationEditRoute extends Route {
  crumb() {
    return [
      {
        name: 'Settings',
        path: 'workspace-settings.subscription_center.settings',
      },
      {
        name: 'Localization',
        path: this.routeName,
      },
    ];
  }

  resetController(
    controller: SubscriptionCenterLocalizationEditController,
    isExiting: boolean,
    transition: Transition,
  ) {
    super.resetController(controller, isExiting, transition);

    controller.lang = null;
  }
}
